
import { mapGetters } from 'vuex';
import { GetConversationById } from '@/constants/getters';
import { getConversationThumbnail, objectToSortedArray } from '@/utils/amp-utils';
import ThumbnailGenerating from '@/assets/svg/thumbnail-generating.svg';

export default {
  props: {
    amp: { required: true, type: Object, default: () => ({}) },
    conversationId: { type: String, default: undefined },
    hideNoImage: { type: Boolean, default: false },
  },

  data() {
    return {
      subscribedToDuplicating: false,
      thumbnailKey: 0,
    };
  },

  computed: {
    ...mapGetters('builderStore', {
      getConversation: GetConversationById,
    }),

    renderImage() {
      return !this.hideNoImage || (this.hideNoImage && this.imageURL);
    },

    imageURL() {
      const { ampType, data } = this.amp;

      if (ampType === 'edetailer') {
        let conversation = this.conversationId ? data?.conversations?.[this.conversationId] : null;

        if (!conversation) {
          conversation = objectToSortedArray(data?.conversations)[0];
        }

        return conversation ? getConversationThumbnail(conversation, this.amp) : '';
      }

      return '';
    },
  },

  created() {
    if (!this.imageURL) {
      // In case a special check is needed in the parent, then we emit if there isn't any image to render
      this.$emit('image:no-image');
    }
  },

  beforeUnmount() {
    if (this.subscribedToDuplicating) {
      this.unsubscribe();
    }
  },

  methods: {
    imageLoadOnError(e) {
      e.target.src = ThumbnailGenerating;
      this.onThumbnailError();
    },

    onThumbnailError() {
      if (this.subscribedToDuplicating || this.amp.ampType === 'website') return;

      this.subscribedToDuplicating = true;

      this.$realtime.subscribeToOrganizationChannel({
        channel: `edetailer:${this.amp.id}`,
        cb: this.realtimeCallback,
      });
    },

    realtimeCallback(ablyMsg) {
      const msg = ablyMsg.data;

      if (msg.name === 'COPY_END' && msg.ampId === this.amp.id) {
        this.unsubscribe();

        this.subscribedToDuplicating = false;
        this.thumbnailKey += 1;
      }
    },

    unsubscribe() {
      this.$realtime.unsubscribeFromOrganizationChannel({
        channel: `edetailer:${this.amp.id}`,
        cb: this.realtimeCallback,
      });
    },
  },
};
